/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 汤尤杯
 * @LastEditTime: 2024-06-29 19:11:02
 */

import bigSports_mixin from '@mixins/badminton/thomasAndUber/bigSportsList_mixin.js'
export default {
  mixins: [bigSports_mixin],
  data() {
    return {
      containerFullClassName: 'containerFull_badminton_thomasAndUber',
      defaultPath: ['badminton', 'thomasAndUber', 'schedule'],
      axiosBaseUrl: '/badminton',
      sportCompetitionType: 'badminton_thomasAndUber', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber】
      themeSeasonArr: [
        {
          sidArr: [
            '5032024',
            '5032022',
            '5032020',
            '5032018',
            '5032016',
            '5032014',
            '5032012',
            '5032010',
            '5032008',
            '5032006',
            '5032004',
            '5032002',
            '5032000',
            '5031998',
            '5031996',
            '5031994',
            '5031992',
            '5031990',
            '5031988',
          ],
          themeIndex: 0,
        },
      ],
    }
  },
}
